export enum QueryKey {
  getTicket = 'getTicket',
  putTicket = 'putTicket',
  postTicket = 'postTicket',
  getProduct = 'getProduct',
}
